<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="700px">
    <v-card v-if="activeMasterListData" style="min-width:400px">
      <v-card-title class="headline pb-5">Add Invoice Sent</v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">New Invoice to send: </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-text-field
              type="number"
              v-model="activeMasterListData.invoiceSent"
              placeholder=""
              prefix="$"
              outlined
              dense
            ></v-text-field>
            <!-- <p class="custom-danger" style="margin-top:-22px;" v-if="invalidInvoiceSent">Invoice Sent must be less than Quote Amount!</p> -->
          </v-col>
        </v-row>
        <!-- <v-row class="mt-2">
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Start Month : </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-menu
              v-model="startCal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="input-field"
                  v-model="activeMasterListData.startMonth"
                  append-icon="event"
                  dense
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="activeMasterListData.startMonth"
                @input="startCal = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">End Month : </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-menu
              v-model="endCal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="input-field"
                  v-model="activeMasterListData.endMonth"
                  append-icon="event"
                  dense
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="activeMasterListData.endMonth"
                @input="endCal = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Remarks: </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-textarea
              v-model="activeMasterListData.remarks"
              placeholder=""
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
        <!-- <v-row v-if="activeMasterListData.activity.length > 0">
          <v-col cols="12" md="12" sm="12" lg="12">
            <h4>Invoice Sent History</h4>
          </v-col>
          <v-col cols="12" md="12" sm="12" lg="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date Time</th>
                    <th class="text-left">Old Amount</th>
                    <th class="text-left">New Amount</th>
                    <th class="text-left">Remark</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in activeMasterListData.activity" :key="index">
                    <td>{{ formatTime(item.timestamp) }}</td>
                    <td>${{ item.old_amount | thousandSeprator }}</td>
                    <td>${{ item.amount | thousandSeprator }}</td>
                    <td>{{ item.remarks }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="green darken-1" text @click="processUpdate()">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex'
// import config from '../config';
export default {
  name: 'InvoiceSentEditModal',
  components: { Loading },
  data() {
    return {
      activeMasterListData: null,
      startCal: false,
      endCal: false,
      isLoading: false
    };
  },
  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value(value) {
      if (value) {
        this.activeMasterListData = Object.assign({}, this.data);
        if (!this.data.id) return
        this.activeMasterListData.id = this.data.id
        this.activeMasterListData.invoiceSent = 0
        this.activeMasterListData.invoicePending = this.data.invoicePending || 0
        this.activeMasterListData.activity = this.data.activity || []
        // this.activeMasterListData.startMonth = this.data.startMonth || ''
        // this.activeMasterListData.endMonth = this.data.endMonth || ''
      }
    }
  },
  computed: {
    ...mapState({
      savedMasterList: state => state.campaign.savedMasterList
    }),
    invalidInvoiceSent() {
      let amt = 0
      if (Array.isArray(this.activeMasterListData.activity)) {
        for (let act of this.activeMasterListData.activity) {
          if (act.amount) {
            amt += Number(act.amount)
          }
        }
      }
      return Number(this.activeMasterListData.quoteAmt) < (amt + Number(this.activeMasterListData.invoiceSent))
    },
    disableMasterLists() {
      return this.$v.activeMasterListData.$invalid
    }
  },
  validations: {
    activeMasterListData: {
      invoiceSent: {
        required
      },
      invoicePending: {
        required
      }
    }
  },
  methods: {
    async processUpdate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      } else if (this.invalidInvoiceSent) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Invoice Sent must be less than Quote Amount!'
        });
        return;
      }
      this.isLoading = true
      let saveData = []
      let activity = []
      if (this.activeMasterListData.activity) {
        activity = Object.assign([], this.activeMasterListData.activity)
      }
      activity.push({
        timestamp: moment().toISOString(),
        amount: Number(this.activeMasterListData.invoiceSent),
        // startMonth: this.activeMasterListData.startMonth,
        // endMonth: this.activeMasterListData.endMonth,
        remarks: this.activeMasterListData.remarks
      })
      this.changeInvoiceSent()
      let totalInvoiceSent = Number(this.data.invoiceSent) + Number(this.activeMasterListData.invoiceSent)
      saveData.push(Object.assign({}, {
        id: this.activeMasterListData.id,
        invoiceSent: totalInvoiceSent,
        invoicePending: this.activeMasterListData.invoicePending,
        activity
      }))
      this.activeMasterListData.activity = Object.assign([], activity)
      // Submit request to save campaign data
      await this.$store.dispatch('campaign/saveCampaignMasterLists', {
        data: saveData
      })
      this.isLoading = false;
      if (!this.savedMasterList) {
        this.$swal({
          text: 'Error Updating Invoice Sent.',
          type: 'error'
        });
        return
      }
      // Show success message
      this.$swal({
        text: 'Successfully updated.',
        type: 'success'
      });
      this.$emit('created', this.activeMasterListData)
      this.clearForm()
      this.close()
    },
    clearForm() {
      this.activeMasterListData = null
    },
    close() {
      this.$emit('input');
    },
    formatTime(value) {
      return moment(value).format('DD-MM-YYYY hh:mm:ss');
    },
    changeInvoiceSent() {
      if (!isNaN(this.activeMasterListData.invoicePending) && !isNaN(this.activeMasterListData.invoiceSent)) {
        if (this.activeMasterListData.invoicePending > 0) {
          this.activeMasterListData.invoicePending = this.activeMasterListData.invoicePending - this.activeMasterListData.invoiceSent
        }
      }
    }
  }
};
</script>
<style scoped>
  .form-label {
    margin-bottom: 0;
    font-size: 15px;
    font-weight: bold;
    padding-top: 0;
  }
  .custom-danger {
    color: #ff5252 !important;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// InvoiceSentEditModal.vue?1b77df44